export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/resume_writing.b32f60c.svg";